/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Consent_RequiredInputs */

const en_site_url_error_consent_required = /** @type {(inputs: Site_Url_Error_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick the usage statement first.`)
};

const id_site_url_error_consent_required = /** @type {(inputs: Site_Url_Error_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centang pernyataan penggunaan dulu.`)
};

/**
* | output |
* | --- |
* | "Tick the usage statement first." |
*
* @param {Site_Url_Error_Consent_RequiredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_consent_required = /** @type {((inputs?: Site_Url_Error_Consent_RequiredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Consent_RequiredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_consent_required(inputs)
	return en_site_url_error_consent_required(inputs)
});